import {Pipe, PipeTransform} from '@angular/core';

function addLeadZero(num) {
  const isNegative = num < 0;
  return (isNegative ? '-' : '') + ('000' + Math.abs(num)).slice(-2);
}

@Pipe({
  standalone: true,
  name: 'FormatTimeout'
})
export class FormatTimeoutPipe implements PipeTransform {

  transform(delta: any, ...args: any[]): any {
    const sec = delta % 60;
    const min = Math.floor(delta % 3600 / 60);
    const h = Math.floor(delta % 86400 / 3600);
    return [h, min, sec].filter(t => t > 0).map(addLeadZero).join(':');
  }
}
